/*
==========================================
STAMP CORE ENGINE  v4.0.0
文件: assets/stamp-core.js

!! 永远不要修改这个文件 !!
加新产品 → 只改 stamp-product-xxx.js 的配置
改UI交互 → 只改 stamp-ui.js

包含：弧形文字引擎 / 右下角浮动预览+灯箱 /
      截图 / Cloudinary上传 / 工具函数
==========================================
*/
window.StampCore = (function () {
  'use strict';

  // ── 墨水颜色表 ──
  const INK_COLOR_MAP = {
    'Black': '#000000', 'Red': '#ff0000', 'Blue': '#0066cc',
    'Green': '#006600', 'Purple': '#663399', 'Brown': '#8B4513',
    'No ink-stamp only': '#000000'
  };

  // ── 工具 ──
  function getAllCanvases() {
    return ['prodStampCanvas','prodMobileCanvasBottom']
      .map(id => document.getElementById(id)).filter(Boolean);
  }

  function updateSliderFill(slider) {
    if (!slider) return;
    const pct = ((+slider.value - +slider.min) / (+slider.max - +slider.min) * 100).toFixed(1);
    slider.style.setProperty('--fill', pct + '%');
  }

  function showMessage(type, text) {
    const el = document.getElementById(type === 'error' ? 'prodErrorMessage' : 'prodSuccessMessage');
    if (!el) return;
    el.textContent = text;
    el.classList.add('show');
    setTimeout(() => el.classList.remove('show'), 5000);
  }

  function isValidEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }

  function getCurrentInkColor() {
    const btn = document.querySelector('.prod-ink-btn.active');
    return INK_COLOR_MAP[btn ? btn.dataset.ink : 'Black'] || '#000000';
  }

  // ── 弧形文字引擎 ──
  function initCurvedText() {
    // 用 requestAnimationFrame 确保CSS渲染完成、canvas有真实尺寸后再生成SVG
    requestAnimationFrame(() => {
      getAllCanvases().forEach(c => {
        if (c && (c.dataset.layout === 'curved-text' || c.dataset.layout === 'photo-upload'))
          generateCurvedText(c);
      });
    });
  }

  function regenerateCurvedText(canvas) {
    const old = canvas.querySelector('.prod-curved-text-svg');
    if (old) old.remove();
    generateCurvedText(canvas);
  }

  function generateCurvedText(canvas) {
    const lines = canvas.querySelectorAll('.prod-text-line[data-position*="curve"]');
    if (!lines.length || !canvas.classList.contains('shape-circle')) return;

    // ✅ 修复文字偏移：优先用 offsetWidth/offsetHeight
    // getBoundingClientRect() 受 scroll/zoom 影响，在元素刚插入 DOM 时可能返回 0
    // 导致 fallback 到 480，而手机端 canvas 实际只有 220px，cx 算错 → 文字偏左
    const w = canvas.offsetWidth  || canvas.getBoundingClientRect().width  || 480;
    const h = canvas.offsetHeight || canvas.getBoundingClientRect().height || 480;
    const cx = w/2, cy = h/2, radius = Math.min(w,h)*0.42;
    const toRad = d => d*Math.PI/180;
    const sweep = 160, arcLen = radius*toRad(sweep);

    // 桌面基准尺寸480px，按实际canvas尺寸等比缩放字号
    const BASE_SIZE = 480;
    const scaleFactor = Math.min(w, h) / BASE_SIZE;

    const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.classList.add('prod-curved-text-svg');
    svg.setAttribute('width', w); svg.setAttribute('height', h);
    svg.style.cssText = 'position:absolute;top:0;left:0;pointer-events:none;overflow:visible;';

    const ink = getCurrentInkColor();

    lines.forEach(line => {
      const pos = line.dataset.position;
      const span = line.querySelector('.prod-curved-text');
      if (!span) return;
      const text = (span.textContent||'').replace(/\s+/g,' ').trim();
      if (!text) return;

      // 字号按canvas尺寸等比缩放，手机端自动缩小
      let fs = (parseFloat(line.dataset.fontsize||'22') || 22) * scaleFactor;
      const font = line.dataset.font || 'Montserrat';
      const fw = line.dataset.fontweight || '700';
      const isScript = /sacramento|pacifico|dancing|cookie|allura/i.test(font);
      const wf = isScript ? 0.80 : 0.65;
      const needed = text.length*(fs*wf+2);
      if (needed > arcLen*0.88) fs = Math.max(6, Math.floor(arcLen*0.88/(text.length*(wf+0.02))));
// ✅ 改后
let rs = parseFloat(line.dataset.radiusscale)||1.0;
// ★ FIX: Liquid 直接输出原始值（如1.12），DOM属性不受stamp-ui.js修正影响
// 下弧超过0.97会渲染到视觉圆外，必须在此处限制
if (pos === 'bottom-curve' && rs > 0.97) rs = 0.97;
const lr = radius*rs;
      const pid = 'curve-'+pos+'-'+Math.random().toString(36).substr(2,9);

      const path = document.createElementNS('http://www.w3.org/2000/svg','path');
      path.setAttribute('id', pid);
      path.setAttribute('fill','none'); path.setAttribute('stroke','none');

      if (pos === 'top-curve') {
        const x1=cx+lr*Math.cos(toRad(-90-sweep/2)), y1=cy+lr*Math.sin(toRad(-90-sweep/2));
        const x2=cx+lr*Math.cos(toRad(-90+sweep/2)), y2=cy+lr*Math.sin(toRad(-90+sweep/2));
        path.setAttribute('d',`M ${x1} ${y1} A ${lr} ${lr} 0 0 1 ${x2} ${y2}`);
      } else if (pos === 'bottom-curve') {
        const x1=cx+lr*Math.cos(toRad(90+sweep/2)), y1=cy+lr*Math.sin(toRad(90+sweep/2));
        const x2=cx+lr*Math.cos(toRad(90-sweep/2)), y2=cy+lr*Math.sin(toRad(90-sweep/2));
        path.setAttribute('d',`M ${x1} ${y1} A ${lr} ${lr} 0 0 0 ${x2} ${y2}`);
      }
      svg.appendChild(path);

      const textEl = document.createElementNS('http://www.w3.org/2000/svg','text');
      textEl.setAttributeNS('http://www.w3.org/XML/1998/namespace','xml:space','preserve');
      textEl.setAttribute('fill', ink);
      textEl.setAttribute('font-size', String(fs));
      textEl.setAttribute('font-family', font);
      textEl.setAttribute('font-weight', fw);
      textEl.setAttribute('letter-spacing', String(Math.max(0.5, Math.round(2*scaleFactor*10)/10)));

      const tp = document.createElementNS('http://www.w3.org/2000/svg','textPath');
      tp.setAttribute('href','#'+pid);
      tp.setAttribute('startOffset','50%');
      tp.setAttribute('text-anchor','middle');
      tp.appendChild(document.createTextNode(text));
      textEl.appendChild(tp);
      svg.appendChild(textEl);
      line.style.opacity = '0';
    });
    canvas.appendChild(svg);
  }

  // ── 右下角浮动预览 + 灯箱（手机端）──
  function initFloatPreview() {
    // ✅ 兼容：liquid 里已静态写好 prodFloatPreview 时，不重复创建
    // 同时兼容旧 thumb ID（prodFloatPreviewThumb）和新 ID（prodFloatThumb）
    let floatEl = document.getElementById('prodFloatPreview');
    if (!floatEl) {
      floatEl = document.createElement('div');
      floatEl.id = 'prodFloatPreview';
      floatEl.className = 'prod-float-preview';
      floatEl.innerHTML =
        '<div class="prod-float-preview-card">' +
          '<div class="prod-float-preview-label">PREVIEW</div>' +
          '<div class="prod-float-preview-thumb" id="prodFloatThumb">' +
            '<span class="prod-float-placeholder">🔍</span>' +
          '</div>' +
        '</div>';
      document.body.appendChild(floatEl);
    } else {
      // 已有静态 DOM：把旧 thumb ID 统一成 prodFloatThumb 供后续代码使用
      const oldThumb = floatEl.querySelector('#prodFloatPreviewThumb');
      if (oldThumb && !document.getElementById('prodFloatThumb')) {
        oldThumb.id = 'prodFloatThumb';
      }
    }

    // ✅ 灯箱：兼容 liquid 静态 DOM（id 可能是 prodFloatLightbox 或 prodPreviewLightbox）
    let lbEl = document.getElementById('prodPreviewLightbox') ||
               document.getElementById('prodFloatLightbox');
    if (!lbEl) {
      lbEl = document.createElement('div');
      lbEl.id = 'prodPreviewLightbox';
      lbEl.className = 'prod-preview-lightbox';
      lbEl.innerHTML =
        '<div class="prod-preview-lightbox-inner">' +
          '<button type="button" class="prod-preview-lightbox-close" id="prodLightboxClose">✕</button>' +
          '<div class="prod-preview-lightbox-canvas" id="prodLightboxCanvas"></div>' +
        '</div>';
      document.body.appendChild(lbEl);
    } else {
      // 统一旧 liquid 里的 close/canvas ID
      const oldClose = lbEl.querySelector('#prodFloatLightboxClose');
      if (oldClose && !document.getElementById('prodLightboxClose')) oldClose.id = 'prodLightboxClose';
      const oldCanvas = lbEl.querySelector('#prodFloatLightboxCanvas,#prodLightboxCanvas');
      if (oldCanvas && !document.getElementById('prodLightboxCanvas')) oldCanvas.id = 'prodLightboxCanvas';
    }

    // ✅ 灯箱点击：用 DOM clone 同步（不用 html2canvas，避免 CORS 空白）
    floatEl.addEventListener('click', _openLightboxByClone);
    const lbCloseEl = document.getElementById('prodLightboxClose');
    if (lbCloseEl) lbCloseEl.addEventListener('click', closeLightbox);
    lbEl.addEventListener('click', e => { if (e.target === lbEl) closeLightbox(); });
    document.addEventListener('keydown', e => { if (e.key==='Escape') closeLightbox(); });

    // 自动刷新缩略图（✅ 修复闪烁：只用 DOM clone，不再交替 html2canvas）
    let _t = null;
    function _doThumbUpdate() {
      const src = getPreviewSource();
      const th  = document.getElementById('prodFloatThumb');
      if (src && th) _refreshThumbByClone(src, th);
    }

    // 首次渲染：等 SVG/字体就绪后更新一次
    setTimeout(_doThumbUpdate, 800);
    setTimeout(_doThumbUpdate, 1800);

    // 表单输入：节流更新（✅ 去掉 html2canvas，只用 clone，不闪烁）
    const form = document.getElementById('prodStampForm');
    if (form) form.addEventListener('input', () => {
      clearTimeout(_t); _t = setTimeout(_doThumbUpdate, 300);
    });

    // MutationObserver：✅ 节流 500ms，避免 SVG 重渲染时每帧都触发
    const src = document.getElementById('prodMobileCanvasBottom') || document.getElementById('prodStampCanvas') || document.getElementById('prodAddressCanvas');
    if (src && window.MutationObserver) {
      let _moTimer = null;
      new MutationObserver(() => {
        // ✅ 节流：500ms 内只触发一次，彻底消除闪烁
        clearTimeout(_moTimer);
        _moTimer = setTimeout(_doThumbUpdate, 500);
      }).observe(src, {childList:true, subtree:true, attributes:true, characterData:true});
    }
    // address canvas 轮询（每 1000ms，降低频率）
    var _ac = document.getElementById("prodAddressCanvas");
    if (_ac) { setInterval(function(){ _doThumbUpdate(); }, 1000); }
  }

  // ✅ 灯箱展开：用 DOM clone 同步主预览，不用 html2canvas（避免 CORS 空白/图片错误）
  function _openLightboxByClone() {
    const lb  = document.getElementById('prodPreviewLightbox');
    const lbc = document.getElementById('prodLightboxCanvas');
    if (!lb || !lbc) return;
    const src = getPreviewSource();
    if (src) {
      lbc.innerHTML = '';
      const clone = src.cloneNode(true);
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      clone.style.cssText = 'pointer-events:none;max-width:100%;width:100%;';
      lbc.appendChild(clone);
      // 弧形文字 SVG 克隆后需要重新定位（SVG position:absolute 依赖父元素尺寸）
      setTimeout(() => {
        if (typeof window.StampCore !== 'undefined' && window.StampCore.generateCurvedText) {
          const cloneCanvas = lbc.querySelector('.prod-stamp-canvas');
          if (cloneCanvas) window.StampCore.generateCurvedText(cloneCanvas);
        }
      }, 100);
    }
    lb.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  function getPreviewSource() {
    return document.getElementById('prodMobileCanvasBottom') ||
           document.getElementById('prodStampCanvas') ||
           document.getElementById('prodAddressCanvas') ||
           // ✅ body-template 用真实 <canvas> 元素
           document.getElementById('prodStampCanvas-composer');
  }


  // ── SVG字体内嵌（修复 html2canvas 不渲染SVG自定义字体）──
  // html2canvas 截图时 SVG 的 font-family 无法跨域加载，降级为系统字体
  // 解决：fetch Google Fonts woff2 文件转 base64，内嵌进 SVG 的 <style>
  async function embedFontsIntoSVG(container) {
    const svgEls = container.querySelectorAll('.prod-curved-text-svg text');
    if (!svgEls.length) return;
    const fontNames = new Set();
    svgEls.forEach(el => {
      const f = el.getAttribute('font-family');
      if (f) fontNames.add(f.replace(/['"]/g,'').trim());
    });
    if (!fontNames.size) return;
    const fontCSS = [];
    for (const name of fontNames) {
      try {
        const cssUrl = 'https://fonts.googleapis.com/css2?family=' + encodeURIComponent(name) + ':wght@400;700&display=swap';
        const cssText = await fetch(cssUrl).then(r => r.text());
        const urlMatches = [...cssText.matchAll(/url\((https:\/\/fonts\.gstatic\.com[^)]+)\)/g)];
        if (!urlMatches.length) continue;
        const fontUrl = urlMatches[urlMatches.length - 1][1];
        const blob = await fetch(fontUrl).then(r => r.blob());
        const b64 = await new Promise(res => { const r = new FileReader(); r.onload = () => res(r.result); r.readAsDataURL(blob); });
        fontCSS.push("@font-face{font-family:'" + name + "';src:url('" + b64 + "') format('woff2');font-weight:100 900;}");
      } catch(e) { console.warn('Font embed skip:', name); }
    }
    if (!fontCSS.length) return;
    container.querySelectorAll('.prod-curved-text-svg').forEach(svg => {
      let defs = svg.querySelector('defs');
      if (!defs) { defs = document.createElementNS('http://www.w3.org/2000/svg','defs'); svg.insertBefore(defs, svg.firstChild); }
      let style = defs.querySelector('style');
      if (!style) { style = document.createElementNS('http://www.w3.org/2000/svg','style'); defs.appendChild(style); }
      style.textContent = fontCSS.join('\n');
    });
  }

  async function refreshThumb() {
    const thumb = document.getElementById('prodFloatThumb');
    if (!thumb) return;
    const src = getPreviewSource();
    if (!src) return;

    // Always show DOM clone immediately (instant, no CORS issues)
    _refreshThumbByClone(src, thumb);

    // Then try html2canvas for higher quality - only replace if non-blank
    if (typeof html2canvas === 'undefined') return;
    try {
      await embedFontsIntoSVG(src);
      const snap = await html2canvas(src, {
        backgroundColor: '#fff', scale: 1, logging: false,
        useCORS: true, allowTaint: true
      });
      // Check if canvas is blank (all white = CORS failure on iOS Safari)
      // Sample 9 pixels across the canvas
      const ctx2 = snap.getContext('2d');
      const W = snap.width, H = snap.height;
      const pts = [[W*0.25,H*0.5],[W*0.5,H*0.3],[W*0.75,H*0.5],[W*0.5,H*0.7],[W*0.5,H*0.5],
                   [W*0.15,H*0.3],[W*0.85,H*0.3],[W*0.15,H*0.7],[W*0.85,H*0.7]];
      const allWhite = pts.every(([x,y]) => {
        const d = ctx2.getImageData(Math.round(x), Math.round(y), 1, 1).data;
        return d[0] > 240 && d[1] > 240 && d[2] > 240;
      });
      if (allWhite) return; // canvas is blank due to CORS - keep DOM clone
      thumb.innerHTML = '';
      const img = document.createElement('img');
      img.src = snap.toDataURL('image/png'); img.alt = 'preview';
      thumb.appendChild(img);
    } catch(e) {
      // html2canvas threw - DOM clone is already showing, nothing to do
    }
  }

  // ── 降级缩略图：DOM clone + transform scale ──────────────────
  // html2canvas 因 CORS 等原因失败时使用。
  // 直接把预览 DOM 克隆后缩放进 110×110 容器。
  // 每次调用都重建（保证文字实时同步）。
  function _refreshThumbByClone(src, thumb) {
    thumb.innerHTML = '';
    const thumbSize = parseInt(thumb.style.width) || thumb.offsetWidth || 72;

    // 产品8：真实 <canvas> 元素，直接截图
    if (src.tagName === 'CANVAS') {
      try {
        const dataUrl = src.toDataURL('image/png');
        const img = document.createElement('img');
        img.src = dataUrl;
        img.alt = 'preview';
        img.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;';
        thumb.appendChild(img);
      } catch(e) {
        thumb.innerHTML = '<span class="prod-float-placeholder">🔍</span>';
      }
      return;
    }

    const srcW = src.offsetWidth  || src.getBoundingClientRect().width  || 300;
    const srcH = src.offsetHeight || src.getBoundingClientRect().height || 200;
    const scale = Math.min((thumbSize - 4) / srcW, (thumbSize - 4) / srcH);

    const outer = document.createElement('div');
    outer.style.cssText =
      'width:' + thumbSize + 'px;height:' + thumbSize + 'px;overflow:hidden;position:relative;background:#fff;';

    // 克隆节点，去除 id 避免重复
    const clone = src.cloneNode(true);
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));

    // 缩放包装层：先铺满原始尺寸，再 scale
    const inner = document.createElement('div');
    inner.style.cssText =
      'position:absolute;top:0;left:0;' +
      'width:' + srcW + 'px;height:' + srcH + 'px;' +
      'transform:scale(' + scale + ');transform-origin:top left;' +
      'pointer-events:none;';
    inner.appendChild(clone);
    outer.appendChild(inner);
    thumb.appendChild(outer);
  }

  function openLightbox() {
    const lb = document.getElementById('prodPreviewLightbox');
    const lbc = document.getElementById('prodLightboxCanvas');
    if (!lb || !lbc) return;
    const src = getPreviewSource();
    if (src && typeof html2canvas !== 'undefined') {
      embedFontsIntoSVG(src).then(() =>
        html2canvas(src, {backgroundColor:'#fff', scale:2, logging:false, useCORS:true})
      ).then(snap => {
          lbc.innerHTML = '';
          snap.style.maxWidth='100%'; snap.style.borderRadius='12px';
          lbc.appendChild(snap);
        }).catch(() => fallbackClone(src, lbc));
    } else if (src) fallbackClone(src, lbc);
    lb.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    const lb = document.getElementById('prodPreviewLightbox');
    if (lb) lb.classList.remove('show');
    document.body.style.overflow = '';
  }

  function fallbackClone(src, container) {
    container.innerHTML = '';
    const clone = src.cloneNode(true);
    clone.removeAttribute('id');
    clone.style.cssText = 'pointer-events:none;max-width:100%;';
    container.appendChild(clone);
  }

  // ── 截图 ──
  async function capturePreview() {
    const canvas = document.getElementById('prodStampCanvas');
    if (!canvas || typeof html2canvas==='undefined') return null;
    try {
      if (document.fonts && document.fonts.ready) await document.fonts.ready;
      await embedFontsIntoSVG(canvas);
      const c = await html2canvas(canvas, {backgroundColor:'#fff', scale:2, logging:false, useCORS:true});
      return c.toDataURL('image/png');
    } catch(e) { console.error('Capture failed:',e); return null; }
  }

  // ── Cloudinary 上传 ──
  async function uploadToCloudinary(base64, cloudName, preset) {
    const fd = new FormData();
    fd.append('file', base64);
    fd.append('upload_preset', preset);
    fd.append('folder', 'stamp-previews');
    const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {method:'POST',body:fd});
    if (!res.ok) { const e=await res.json(); throw new Error(e.error?.message||'Upload failed'); }
    return (await res.json()).secure_url;
  }

  // ── 照片显示 ──
  function updatePhotoDisplay(processedImage) {
    // 固定插图（ink-color滤镜类型）
    document.querySelectorAll('.prod-illustration-img').forEach(img => { img.src = processedImage; });

    getAllCanvases().forEach(canvas => {
      if (!canvas) return;
      const layout = canvas.dataset.layout;

      if (layout === 'curved-text') {
        // curved-text 布局：照片区是 .prod-illustration-center.prod-photo-preview
        const cp = canvas.querySelector('.prod-illustration-center.prod-photo-preview');
        if (cp) {
          // 移除占位符
          const placeholder = cp.querySelector('.prod-photo-placeholder');
          if (placeholder) placeholder.remove();
          // 找或创建底层照片 img（在 overlay 下方）
          let photoImg = cp.querySelector('img.prod-uploaded-photo');
          if (!photoImg) {
            photoImg = document.createElement('img');
            photoImg.className = 'prod-uploaded-photo';
            photoImg.alt = 'Your photo';
            photoImg.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;transform-origin:center center;z-index:1;';
            // 插在 overlay 之前（或作为第一个子元素）
            const overlay = cp.querySelector('.prod-body-overlay');
            if (overlay) cp.insertBefore(photoImg, overlay);
            else cp.appendChild(photoImg);
          }
          photoImg.src = processedImage;
        }

      } else if (layout === 'photo-upload') {
        // photo-upload 布局：照片区是 .prod-photo-preview-area
        const pa = canvas.querySelector('.prod-photo-preview-area');
        if (pa) pa.innerHTML = `<img src="${processedImage}" alt="Your photo" style="width:100%;height:100%;object-fit:contain;border-radius:inherit;">`;

      } else if (layout === 'image-left') {
        // image-left 布局：客人上传照片 → 替换左侧插图区 .prod-illustration-left img
        const il = canvas.querySelector('.prod-illustration-left');
        if (il) {
          let img = il.querySelector('img.prod-illustration-img');
          if (!img) {
            img = document.createElement('img');
            img.className = 'prod-illustration-img';
            img.alt = 'Your photo';
            img.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;';
            il.appendChild(img);
          }
          img.src = processedImage;
        }
      }
    });

    const pg = document.getElementById('prodPhotoPositionGroup');
    if (pg) pg.style.display = 'block';
  }

  // ── 公开 API ──
  return {
    INK_COLOR_MAP, getAllCanvases, updateSliderFill, showMessage,
    isValidEmail, getCurrentInkColor,
    initCurvedText, regenerateCurvedText, generateCurvedText,
    initFloatPreview, refreshThumb,
    capturePreview, uploadToCloudinary, updatePhotoDisplay
  };
})();